import React, { useState } from 'react';
import { useAppContext, SET_HOUSE_SIZE } from '../context/AppContext';

const HouseSize = ({ selectedHouseSize }) => {
	const { dispatch } = useAppContext();

	const handleSizeChoice = (houseSizeId) => {
		console.log('HouseSize received click on', houseSizeId);
		dispatch({ type: SET_HOUSE_SIZE, payload: houseSizeId });
	};

	return (
		<div className='facade-size-container'>
			<h3>House Size</h3>
			<div className='facade-size-buttons-container'>
			<button
				className={`facade-size-button ${selectedHouseSize === 12 ? 'selected' : ''}`}
				onClick={() => handleSizeChoice(12)}>
				12'
			</button>
			<button
				className={`facade-size-button ${selectedHouseSize === 15 ? 'selected' : ''}`}
				onClick={() => handleSizeChoice(15)}>
				15'
			</button>
			<button
				className={`facade-size-button ${selectedHouseSize === 18 ? 'selected' : ''}`}
				onClick={() => handleSizeChoice(18)}>
				18'
			</button></div>
		</div>
	);
};

export default HouseSize;
